var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.438 6.95c-4.263-4.263-11.213-4.263-15.475 0a10.85 10.85 0 0 0-3.213 7.737c0 2.925 1.138 5.675 3.213 7.738a10.9 10.9 0 0 0 7.737 3.2c2.8 0 5.6-1.063 7.738-3.2 4.262-4.263 4.262-11.213 0-15.475M14.7 23.725c-4.975 0-9.037-4.05-9.037-9.038 0-4.987 4.05-9.025 9.037-9.025s9.038 4.05 9.038 9.038c0 4.987-4.05 9.037-9.038 9.037z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.512 10.55a.963.963 0 0 0-.962.962v6.35c0 .525.425.95.962.95.538 0 .95-.425.95-.95v-6.35a.96.96 0 0 0-.95-.962M12.888 10.55a.95.95 0 0 0-.95.962v6.35a.95.95 0 1 0 1.9 0v-6.35a.96.96 0 0 0-.95-.962"
  }))));
};
export default SvgPause;